import Swiper, {Navigation} from "../../assets/.npm/node_modules/swiper";

export default () => {
    let swiperNew0 = new Swiper(".slider-new-0", {
        modules: [Navigation],
        slidesPerView: 1, 
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".new-0-next",
          prevEl: ".new-0-prev",
        }, 
        breakpoints: {
            580: {
                slidesPerView: 2, 
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
        }, 
      });
    
      let swiperNew1 = new Swiper(".slider-new-1", {
        modules: [Navigation],
        slidesPerView: 1, 
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".new-1-next",
          prevEl: ".new-1-prev",
        }, 
        breakpoints: {
            580: {
                slidesPerView: 2, 
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
        }, 
      });
    
      let swiperNew2 = new Swiper(".slider-new-2", {
        modules: [Navigation],
        slidesPerView: 1, 
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".new-2-next",
          prevEl: ".new-2-prev",
        }, 
        breakpoints: {
            580: {
                slidesPerView: 2, 
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
        }, 
      });
        
        let swiperNew3 = new Swiper(".slider-new-3", {
            modules: [Navigation],
        slidesPerView: 1, 
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".new-3-next",
          prevEl: ".new-3-prev",
        }, 
        breakpoints: {
            580: {
                slidesPerView: 2, 
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
        }, 
      });
}
  
